import { useState } from 'react';
import { Link } from 'react-router'; // For navigation links (optional)
import styled from 'styled-components';
import {base} from '../Config/app';
import {Ts, LangSwitcher} from '../Config/switcher';
import {SearchControl} from '../Shared/InputControl';
import { ScrollTo } from '../Shared/ViewControl';
import SignModal from '../Sign/SignModal';
import SignUp from '../Sign/SignUp';
import Api from '../Shared/Api';
import { ProfileMain } from '../Profile/Profile';


const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  background-color: #f5f5f5;
  height: 5rem;
`;

const Logo = styled.img`
  height: 5rem;
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  vertical-align: middle;

    @media (orientation: portrait) { 
      flex-direction: column;
      gap: 5px;
      max-width: 5rem;
      max-height: 5rem;
  }
`;



const Header = ({lang, onLang, onSearch, account}) => {

  const [showing, Showing] = useState(false)
  const [register, Register] = useState(false)

  const T = (value, key='header') => Ts(lang, key, value)

  return (
    <HeaderContainer>
      <Link to="/">
        <Logo src={base.logo} alt={base.domain} title={base.name} />
      </Link>

      <LangSwitcher lang={lang} onLang={onLang} />
      <SearchControl onSearch={onSearch} />

      <NavLinks>
        <ScrollTo to="about" label={T('about')} />
        <ScrollTo to="articles" label={T('article')} />
        <ScrollTo to="contact" label={T('contact')} />
        <ScrollTo to="GetApp" label={T('download')} />
        <Link className="d-inline p-3" to="/timer">Timer</Link>

<div className='whatsapp-us'>
    <Link to="https://wa.me/+212660800630" target="_blank" rel="noopener noreferrer">
      <img src="images/wathsapp.png" alt="wathsapp" title="wathsapp" />
    </Link>
</div>

        <ProfileMain lang={lang} account={account} Login={Showing} />

      </NavLinks>

<SignModal 
  lang={lang} 
  app={account.Service}
  show={showing}
  logo={base.logo}
  onHide={()=>{Showing(false)}}
/>   


{register ?
<SignUp 
    api={Api}
    app={account.Service}
    show={register}
    onHide={()=>{Register(false)}}
/> 
: null }


    </HeaderContainer>
  );
};

export default Header;

// Landing/Links.js from ClubDigital/Landing/Header.js 
